import { createTheme } from '@mui/material';
import type { SeasonalThemeDefinition } from '../../SeasonalTheme';
import { ChristmasHeaderTree } from './ChristmasHeaderTree';
import { ChristmasLoader } from './ChristmasLoader';

/**
 * Christmas: a thin string of fairy lights along the top of the header, a tree in the header (click it three times quickly
 * for the easter egg) and a tree loader with falling snow. The app bar itself keeps its regular colours.
 */
export const christmasTheme: SeasonalThemeDefinition = {
  name: 'christmas',
  label: 'Jul 🎄',
  // The lights are positioned absolutely along the header's top edge, so the (static) app bar must be a
  // positioned ancestor. `relative` lays out exactly like `static`, it only becomes a containing block.
  extendMuiTheme: (theme) =>
    createTheme(theme, {
      components: { MuiAppBar: { styleOverrides: { positionStatic: { position: 'relative' } } } },
    }),
  HeaderDecoration: ChristmasHeaderTree,
  Loader: ChristmasLoader,
};

export default christmasTheme;
